/**
 * @generated SignedSource<<352ed55fe28a242fdd6e724a332b03fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRow$data = {
  readonly __typename: "ProductInfoComponentLinkRow";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowLink">;
  readonly " $fragmentType": "ProductDetailsRow";
} | {
  readonly __typename: "ProductInfoComponentLongTextRow";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowLongText">;
  readonly " $fragmentType": "ProductDetailsRow";
} | {
  readonly __typename: "ProductInfoComponentNumberRow";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowNumber">;
  readonly " $fragmentType": "ProductDetailsRow";
} | {
  readonly __typename: "ProductInfoComponentStatusRow";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowStatus">;
  readonly " $fragmentType": "ProductDetailsRow";
} | {
  readonly __typename: "ProductInfoComponentTagsRow";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowTags">;
  readonly " $fragmentType": "ProductDetailsRow";
} | {
  readonly __typename: "ProductInfoComponentTextRow";
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowText">;
  readonly " $fragmentType": "ProductDetailsRow";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ProductDetailsRow";
};
export type ProductDetailsRow$key = {
  readonly " $data"?: ProductDetailsRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRow",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRowNumber"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoComponentNumberRow",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRowText"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoComponentTextRow",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRowLongText"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoComponentLongTextRow",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRowTags"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoComponentTagsRow",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRowLink"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoComponentLinkRow",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsRowStatus"
        },
        (v0/*: any*/)
      ],
      "type": "ProductInfoComponentStatusRow",
      "abstractKey": null
    }
  ],
  "type": "ProductInfoComponentRow",
  "abstractKey": "__isProductInfoComponentRow"
};
})();

(node as any).hash = "25eb4f9bfa09c4537fa84924b195b272";

export default node;
